import { sendInfrastructureAnalytics } from '../utils';

interface ITrackInfrastructureCategoryClick {
  infrastructureType: string;
  isSelected: boolean;
}

export const trackInfrastructureCategoryClick = ({
  infrastructureType,
  isSelected,
}: ITrackInfrastructureCategoryClick) =>
  sendInfrastructureAnalytics({
    action: 'click_chips_infra',
    label: isSelected ? 'show' : 'hide',
    infrastructureType,
  });
